var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-chip",class:_vm.sm ? 'sm' : 'lg',style:(("background: " + _vm.backgroundColor + "; color: " + _vm.textColor))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }